import { connect } from 'react-redux';
import ConstructorBanners from './ConstructorBanners';

const ConstructorBannersComponent = connect(
    function mapStateToProps(state, {visible, landing, onClose, onSave}) {
        return {
            goalEntries: state.goalEntries.list,
            publisherId: state?.user?.publisher?.id || '',
            offer: state.offers.list[0],
            links: state.links.list,
            landing: landing,
            visible: visible,
            onClose: onClose,
            onSave: onSave
        };
    },
    function mapDispatchToProps() {
        return {};
    }
)(ConstructorBanners);

export default ConstructorBannersComponent;
